
<template>
  <div class="invitacion-container" ref="containerRef">
    <div class="invitacion-card" ref="cardRef">

      <!-- 👑 CORONA SUPERIOR (.PNG ORIGINAL) -->
      <img src="@/assets/CORON.png" class="corona-sello" alt="Corona de XV Años" ref="coronaRef" />

      <!-- 🖼️ NUEVA IMAGEN DEBAJO DE LA CORONA -->
      <img src="@/assets/A4993CC0-69CD-4A54-8D6A-DEE5B5757B95.png" class="imagen-subcorona" alt="Detalle decorativo" ref="imagenSubCoronaRef" />

      <p ref="titulo" class="titulo-principal">
        TENEMOS EL HONOR DE INVITARTE<br>
        A LA CELEBRACIÓN DE MIS 
      </p>

      <h1 ref="nombres" class="subtitulo">QUINCE AÑOS
              <h1 ref="nombres" class="subtitulo1">Sábado<br> 28 Noviembre 2026    </h1>

      </h1>

      <p ref="fecha" class="fecha"></p>

      <!-- INDICADOR DE SCROLL -->
      <div class="scroll-indicator" aria-label="Desliza hacia abajo">
        <svg viewBox="0 0 24 24" class="scroll-arrow">
          <path d="M12 4 V19 M5 12 L12 19 L19 12" />
        </svg>
      </div>

    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import gsap from 'gsap';

export default {
  name: 'InvitacionIdioma',
  emits: ['idioma-seleccionado'],
  setup(_, { emit }) {
    const containerRef = ref(null);
    const cardRef = ref(null);
    const coronaRef = ref(null);
    const imagenSubCoronaRef = ref(null);
    const titulo = ref(null);
    const nombres = ref(null);
    const fecha = ref(null);
    const idiomaSeccion = ref(null);
    const estaAnimando = ref(false);

    const seleccionar = (idioma) => {
      if (estaAnimando.value) return;
      estaAnimando.value = true;

      gsap.to(cardRef.value, {
        opacity: 0,
        scale: 0.95,
        y: -10,
        duration: 0.6,
        ease: 'power2.in',
        onComplete: () => {
          emit('idioma-seleccionado', idioma);
        }
      });
    };

    onMounted(() => {
      // Animación de entrada escalonada estilo lujo con GSAP
      gsap.timeline({ delay: 0.3 })
        .from(coronaRef.value, {
          opacity: 0,
          scale: 0.5,
          y: -30,
          duration: 1.2,
          ease: 'back.out(1.7)',
        })
        .from(imagenSubCoronaRef.value, {
          opacity: 0,
          scale: 0.8,
          y: 20,
          duration: 1,
          ease: 'power2.out',
        }, '-=0.7')
        .from(titulo.value, {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: 'power2.out',
        }, '-=0.6')
        .from(nombres.value, {
          opacity: 0,
          scale: 0.9,
          y: 30,
          duration: 1.2,
          ease: 'power3.out',
        }, '-=0.5')
        .from(fecha.value, {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: 'power2.out',
        }, '-=0.8')
        .from(idiomaSeccion.value, {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: 'power2.out',
        }, '-=0.8');
    });

    return {
      seleccionar,
      containerRef,
      cardRef,
      coronaRef,
      imagenSubCoronaRef,
      titulo,
      nombres,
      fecha,
      idiomaSeccion,
      estaAnimando
    };
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700&family=Great+Vibes&family=Playfair+Display:ital,wght@0,500;0,600;0,700;1,400;1,500&family=Montserrat:wght@400;500;600;700&display=swap');

/* CONTENEDOR PRINCIPAL - MISMO FONDO Y TEXTURA */
.invitacion-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  padding: 1rem;
  margin: 0;
  box-sizing: border-box;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  background-color: #d8e9f3;
  background-image: 
    linear-gradient(rgba(0, 0, 0, 0.566), rgba(0, 0, 0, 0.594)), 
    url('@/assets/B3D70B5E-2599-498C-923E-4B6C6082F8F9.png');  
}

.invitacion-card {
  position: relative;
  padding: 40px 24px;
  margin: 0 auto;
  border-radius: 18px;
  background-color: transparent;
  text-align: center;
  width: 100%;
  max-width: 420px;
  z-index: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  will-change: opacity, transform;
}

/* 👑 CORONA IMAGEN .PNG */
.corona-sello {
  width: 195px;
  height: auto;
  margin: 0 auto 10px auto;
  display: block;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.15));
}

/* 🖼️ ESTILOS PARA LA NUEVA IMAGEN DEBAJO DE LA CORONA */
.imagen-subcorona {
  width: 240px !important;
  height: auto;
  margin: 0 auto 15px auto;
  display: block;
  object-fit: contain;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.12));
}

/* TEXTO SUPERIOR */
.titulo-principal {
  font-family: 'Cinzel', 'Playfair Display', serif;
  font-size: 0.95rem;
  color: #4979a0;
  margin-bottom: 1rem;
  letter-spacing: 2px;
  line-height: 1.6;
  font-weight: 600;
  text-transform: uppercase;
}

/* TÍTULO PRINCIPAL "XV AÑOS" EN AZUL CELESTE */
.subtitulo {
  font-family: 'Cinzel', 'Playfair Display', serif;
  font-size: 2.8rem !important;
  margin: 0 0 0.5rem 0;
  font-weight: 700;
  letter-spacing: 4px;
  text-align: center;
  display: inline-block;
  width: 100%;
  box-sizing: border-box;
  text-transform: uppercase;
  color: #8aa4ba;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
.subtitulo1 {
  font-family: 'Cinzel', 'Playfair Display', serif;
  font-size: 1.2rem !important;
  margin: 0 0 0.5rem 0;
  font-weight: 700;
  letter-spacing: 4px;
  text-align: center;
  display: inline-block;
  width: 100%;
  box-sizing: border-box;
  text-transform: uppercase;
  color: #e8eff5;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

/* NOMBRE PRINCIPAL EN CURSIVA DORADA */
.fecha {
  font-family: 'Great Vibes', cursive, serif;
  font-size: 2.5rem !important;
  color: #cba56b;
  margin-bottom: 2rem;
  letter-spacing: 1px;
  font-weight: 500;
  opacity: 0.95;
}

/* INDICADOR DE SCROLL */
.scroll-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  animation: flechaScroll 1.6s ease-in-out infinite;
}

.scroll-arrow {
  width: 30px;
  height: 30px;
  fill: none;
  stroke: #cba56b;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

@keyframes flechaScroll {
  0%, 100% {
    transform: translateY(0);
    opacity: 0.65;
  }
  50% {
    transform: translateY(10px);
    opacity: 1;
  }
}

.seccion-idiomas {
  margin: 1rem 0 0;
  width: 100%;
}

.opciones-idioma {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* 🔘 BOTÓN INGRESAR CELESTE Y BORDE DORADO */
.btn-idioma {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  padding: 14px 28px;
  border-radius: 25px;

  background: linear-gradient(135deg, #ffffff 0%, #f0f7fc 100%);
  color: #4979a0;
  text-decoration: none;

  font-family: 'Playfair Display', serif;
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 2px;
  text-transform: uppercase;
  line-height: 1;

  border: 1.5px solid #cba56b;

  box-shadow:
    0 4px 12px rgba(73, 121, 160, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);

  overflow: hidden;
  cursor: pointer;
  width: 100%;
  max-width: 240px;
  margin: 0 auto;

  transition: all 0.35s ease;
}

.btn-idioma:hover:not(:disabled) {
  transform: translateY(-2px) scale(1.02);
  background: #ffffff;
  box-shadow:
    0 6px 18px rgba(73, 121, 160, 0.25),
    0 0 12px rgba(203, 165, 107, 0.3);
}

.btn-idioma:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* 📨 Icono del sobre en color celeste */
.icono-sobre {
  width: 18px;
  height: 18px;
  fill: #4979a0;
  position: relative;
  z-index: 2;
}

/* EFECTO BRILLO DORADO SOBRE EL BOTÓN */
.btn-idioma::before {
  content: "";
  position: absolute;
  top: 0;
  left: -120%;
  width: 70%;
  height: 100%;
  background: linear-gradient(
    120deg,
    transparent,
    rgba(203, 165, 107, 0.25),
    transparent
  );
  transform: skewX(-22deg);
  animation: brilloDorado 3.5s infinite;
  z-index: 1;
}

@keyframes brilloDorado {
  0% { left: -120%; }
  100% { left: 180%; }
}

.btn-idioma span {
  position: relative;
  z-index: 2;
}

@media (max-width: 480px) {
  .invitacion-card {
    padding: 2rem 1rem;
  }
  .corona-sello {
    width: 160px;
  }
  .imagen-subcorona {
    width: 120px;
  }
  .titulo-principal {
    font-size: 0.85rem;
  }
  .subtitulo {
    font-size: 2.3rem !important;
  }
  .fecha {
    font-size: 2.1rem !important;
  }
}
</style>
